/*=========================================================================================
  File Name: usersActions.js
  Description: Vuex Store - users actions
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    getUsers({commit}) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/users', method: 'GET'})
                .then(({data}) => {
                    commit('SET_PERMISSIONS', data.permissions);
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    viewUser({commit}, id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/users/view/' + id, method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    createUser({commit}) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/users/create', method: 'GET'})
                .then((user) => {
                    resolve(user.data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    storeUser({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/users/store', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    editUser({commit}, id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/users/edit/' + id, method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    updateUser({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({
                url: state.API_URL + '/auth/organization/users/update/' + payload.id,
                data: payload.data,
                method: 'POST'
            })
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    deleteUser({commit}, id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/users/delete/' + id, method: 'DELETE'})
                .then(({data}) => {
                    commit('user_remove_success', id);
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    acceptIdentityDocument({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/users/accept-identity', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    declineIdentityDocument({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/users/decline-identity', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    acceptAddressDocument({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/users/accept-address', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    declineAddressDocument({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/users/decline-address', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    markNotificationsRead({commit}) {
        return new Promise((resolve) => {
            axios({url: state.API_URL + '/auth/notifications/mark_all_read', method: 'POST'})
                .then(() => {
                    resolve();
                });
        })
    },

    markNotificationRead({commit}, id) {
        return new Promise((resolve) => {
            axios({url: state.API_URL + '/auth/notifications/mark_read', data: {id: id}, method: 'POST'})
                .then(() => {
                    resolve();
                });
        })
    },
};
